import React from "react"

const TextareaIndicator = props => {
  return (
    <span className="text-area-counter">
      {(props?.value?.length ? props?.value?.length : 0) + " / " + props?.total}
    </span>
  )
}

export default TextareaIndicator
